/**
 * Central registry of every product-onboarding flow's identity and priority.
 *
 * Consumer widgets (e.g. `call-intel-onboarding`) import their entry from here
 * so all flow ids and priorities live in one place and stay globally unique.
 * Higher `priority` wins when multiple flows compete for the same hotspot target.
 */
export const ONBOARDING_FLOW = {
  CI_BASE: { id: 'ci-base', priority: 1 },
} as const;

export type OnboardingFlowKey = keyof typeof ONBOARDING_FLOW;
